export const FIRST_TIME_BUYER_FLOW = {
  SmartSearchBuyingProcessStage: 0,
  SmartSearchBasicDetails: 1,
  SmartSearchInitialRate: 2,
  SmartSearchLiveResults: 3,
  UserCreate: 4,
} as const;
